import { inject, Injectable } from '@angular/core';
import { ApiService } from '@letly/services';
import { Observable } from 'rxjs';
import { ApiResponse } from '@letly/models';
import { environment } from '../../../../../env/environment';
import { NotificationPreference, NotificationPreferencePatch } from '../models/notification.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private apiService = inject(ApiService);

  getPreferences(): Observable<ApiResponse<NotificationPreference>> {
    return this.apiService.get<NotificationPreference>(environment.notificationBaseUrl + '/v1/users/self/preferences');
  }

  updatePreferences(patch: NotificationPreferencePatch): Observable<ApiResponse<NotificationPreference>> {
    return this.apiService.patch<NotificationPreference>(`${environment.notificationBaseUrl}/v1/users/self/preferences`, patch);
  }
}
